export default __webpack_public_path__ + "static/media/volleyball.ab43ce0d.png";